import { AfterViewInit, ChangeDetectionStrategy, Component, OnChanges, SimpleChanges, ViewChild, input } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { faFire } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-view-positions',
  templateUrl: './view-positions.component.html',
  styleUrl: './view-positions.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ViewPositionsComponent implements AfterViewInit, OnChanges {
  faFire = faFire;

  positionList = input.required<any>();
  positions = new MatTableDataSource<any>();
  displayedColumns!: string[];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort: MatSort = new MatSort;

  constructor() {
    this.displayedColumns = [
      'position',
      'region',
      'forest'
    ]
  }

  ngOnChanges(changes: SimpleChanges) {
    this.positions.data = this.positionList();
  }

  ngAfterViewInit() {
    this.positions.sort = this.sort;
    this.positions.paginator = this.paginator;

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
  }
}
